import Recherche from './Recherche';
import Breadcrumb from './Breadcrumb';
import { BASE_URL } from '../Utils/base_url';
import '../Css/hero.css';
import HeroSkeleton from './HeroSkeleton';
const Hero = ({ ou, qoui, date, heure, personne,imageLoad,imageUrl }) => {
   
    return (
        imageLoad === true ?
            <HeroSkeleton />
            :
            <div className='hero'>
                <div className='hero_image'>

                    <div className='img'>
                        <img src={BASE_URL + imageUrl} className="shadow" alt='hero home' />
                    </div>

                    <div className='content_hero'>
                        <Breadcrumb />
                        <h1 className='text-center'>E-kaly</h1>
                        <div className='recherche_bloc'>
                            <Recherche ou={ou} qoui={qoui} datePrise={date} heurePrise={heure} personnePrise={personne} />
                        </div>
                    </div>
                </div>
            </div>

    );
}

export default Hero